import { Show } from "solid-js"

type Props = {
  label: string
  value: string
  onInput: (value: string) => void
  placeholder?: string
  class?: string
  onSubmit?: () => void
}

export default function LabeledInput(props: Props) {
  return (
    <div class="flex flex-col gap-2">
      <Show when={props.label}>
        <label class="text-sm font-medium text-gray-700 dark:text-gray-300">
          {props.label}
        </label>
      </Show>
      <input
        type="text"
        value={props.value}
        onInput={(e) => props.onInput(e.currentTarget.value)}
        onKeyDown={(e) => e.key === 'Enter' && props.onSubmit?.()}
        class={`h-9 rounded-md border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-3 text-sm ${props.class}`}
        placeholder={props.placeholder}
      />
    </div>
  )
}
